"use client";
import React, { useState, useEffect } from "react";
import { useRouter } from "next/navigation";
import { TitleCard, NormalStyles, TitleCardWithoutClick } from "@/layouts/styles/ssr.style";
import CardArtist from "./card-artist";
import { IDetailStory, ResponseTypes } from "@/types/constants";
import { definitions } from "@/services/metruyenvl";
import { formatValueReadings, renderContentWithLineBreaks } from "@/utils/formatted";
import chapterAPI from "@/services/chapter_api";
import EmojiIntroduce from "./emoji-introduce";
import Image from "next/image";
import { Skeleton } from "antd";

function Introduce({ book, stats }: { book: definitions["do.BookDO"]; stats?: definitions["do.StatsDO"] }) {
    const [latestChapters, setInfoLastChapter] = useState<definitions["do.ChapterContentRes"]>();
    const router = useRouter();

    useEffect(() => {
        const getLastChapter = async () => {
            try {
                const res: ResponseTypes = await chapterAPI.getChaptersLatestByMangaSlug(book.slug);
                let data = res.data;
                setInfoLastChapter(data[0]);
            } catch (error) {
                console.log(error);
            }
        };
        if (book?.slug != undefined) {
            getLastChapter();
        }
    }, [book]);

    return (
        <div className="md:grid gap-x-20" style={{ gridTemplateColumns: "1fr 0.6fr" }}>
            <div>
                {book?.description ? <p className="text-justify p-1 pb-5" dangerouslySetInnerHTML={{ __html: renderContentWithLineBreaks(book?.description) }}></p> : <Skeleton active className="pb-3" />}
                <div className="border-solid w-full border-t border-gray-300 md:flex items-center gap-x-6 p-2">
                    <div className="w-24">
                        <TitleCard>Cảm xúc</TitleCard>
                    </div>
                    <EmojiIntroduce stats={stats} />
                </div>
                <div className="border-solid w-full border-t border-gray-300 flex items-center justify-between md:justify-start gap-x-6 p-5 pl-2">
                    <div className="w-24">
                        <TitleCard>Đề cử</TitleCard>
                    </div>
                    <div className="flex items-center gap-x-1">
                        <Image src="/trophy.png" alt="" width="6" height="6" className="h-6 w-6" />
                        {stats ? formatValueReadings(stats?.suggests_count ?? 0) : <Skeleton.Button active size="small" />}
                    </div>
                </div>
                <div className="border-solid w-full border-t border-b border-gray-300 flex items-center gap-x-6 p-5 pl-2">
                    <div className="w-24">
                        <TitleCard>Chương mới</TitleCard>
                    </div>
                    {latestChapters?.title ? (
                        <div
                            className="line-clamp-1 text-sm cursor-pointer"
                            onClick={() => {
                                router.push(`/truyen/${book.slug}/${latestChapters?.slug}`);
                            }}
                        >
                            {latestChapters?.title ?? ""}
                        </div>
                    ) : (
                        <Skeleton active title={false} paragraph={{ rows: 1, width: ["60%"] }} />
                    )}
                </div>
            </div>
            <CardArtist book={book} />
        </div>
    );
}

export default Introduce;
